import React from 'react';

const HandWithMoneySvg = (props) => (
    <svg
        id="hand-with-money_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 48 48"
        xmlSpace="preserve"
        {...props}
    >
        <style>{'.hand-with-money_svg__st0{fill:#1d0a32}'}</style>
        <path
            className="hand-with-money_svg__st0"
            d="M47.5 21.9c.5-.2.6-.8.5-1.3l-8-20c-.1-.3-.3-.5-.6-.6-.4 0-.7 0-.9.1-8.6 5-13.1 6.5-17.7 8s-9.3 3.1-18.2 8c-.4.2-.6.8-.4 1.2l2 5.1c-.8.4-2 1-3.5 1.6-.2.1-.4.3-.5.5-.1.2-.1.5 0 .8l8 19c.1.3.3.5.6.6 0 .1.1.1.2.1.2 0 .3 0 .5-.1 7.1-3.8 12.9-6.5 17.6-8.4.3 4.2 1.9 10.5 2 10.8.1.5.5.8 1 .8h.2c.5-.1.9-.7.7-1.2 0-.1-2-7.9-2-11.7 0-3.6 1.1-5.6 2.7-8.4 1.2-2.2 2.8-5 4.2-9.4.9-3 1.7-3.3 2.1-3.3h.1c.6.7 0 4.2-.5 6.8-.6 3.5-1.3 7.6-.6 10.4.1.5.7.9 1.2.8.5-.1.9-.7.8-1.2-.3-1.3-.3-3-.1-4.8 2-.9 4-1.7 5.9-2.7.7 1.5 1.2 3.7 1.2 4.7 0 .6-1.3 3.7-2.4 6.1C41.4 39 40 42.3 40 44v3c0 .6.4 1 1 1s1-.4 1-1v-3c0-1.4 2-5.8 3.4-9.1C47.1 31 48 29 48 28c0-1.5-.6-4-1.4-5.7.3-.1.6-.3.9-.4zm-7.9-9.2c-.4-.5-1-.7-1.6-.7-2.2 0-3.3 2.4-4 4.7-1.3 4.2-2.8 6.7-4 9-.4.7-.8 1.4-1.1 2.1-2.4.9-5.1 1.9-8.2 3.3-.5.2-.7.8-.5 1.3.2.4.5.6.9.6.1 0 .3 0 .4-.1 2.3-1 4.4-1.9 6.3-2.6-.4 1.2-.6 2.5-.7 4-4.7 1.8-10.4 4.6-17.5 8.3L2.3 25.5c1-.4 1.9-.9 2.5-1.2l5.2 13c.1.3.3.5.6.6.1 0 .2.1.3.1.2 0 .3 0 .5-.1.9-.5 2.2-1.2 4-2.1.5-.3.7-.9.4-1.3-.3-.5-.9-.7-1.3-.4-1.2.6-2.2 1.2-3 1.6L4.3 17.5c8.3-4.5 12.8-6 17.1-7.5 4.6-1.5 9-2.9 17.1-7.6l7.2 18.1c-2.2 1.2-4.4 2.2-6.6 3.1.1-.9.3-1.7.4-2.6.9-4.3 1.2-6.9.1-8.3z"
        />
        <path
            className="hand-with-money_svg__st0"
            d="M25.7 14c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.3-5-5-5zm0 8c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.4 3-3 3zm-10-2c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.4-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.5 1-1 1z"
        />
    </svg>
);

HandWithMoneySvg.displayName = 'HandWithMoneySvg';
export default HandWithMoneySvg;
